export const radius = {
  basic: '2px',
  focus: '2px',
  modal: '4px',
};
